<template>
    <div class="bannerNode flexColumn">
        <top-tab
            :topBarDatas="topBarDatas"
        ></top-tab>
        <div class="contentBox">
            <box-border
                title="项目总体进度"
                :boxStyle="{
                    'grid-row': '1 / span 3'
                }"
            >
                <span class="PAVstyle">
                    P: {{ overallProgress.otherObj.P }} A: {{ overallProgress.otherObj.A }} V: {{ overallProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="overallProgress"
                    :option="overallProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="设计进度"
                :boxStyle="{
                    'grid-row': '1 / span 2'
                }"
            >
                <span class="PAVstyle">
                    P: {{ engineeringProgress.otherObj.P }} A: {{ engineeringProgress.otherObj.A }} V: {{ engineeringProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="engineeringProgress"
                    :option="engineeringProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="项目进度概览"
                :boxStyle="{
                    'grid-row': '4 / span 3'
                }"
            >
                <Table
                    v-bind="tableObj"
                    :tableStyle="{
                        height: '100%',
                    }"
                >
                    <template #default="{ value, index }">
                        <span v-if="index == 7 || index == 4" :style="{
                            'font-size': '0.12rem',
                            'display': 'line-block',
                            'width': '0.16rem',
                            'height': '0.16rem',
                            'vertical-align': 'middle',
                            'background-image': value.split('%')[0] > 0 ? `url(${require('@/assets/img/upArrow.svg')})` : (value.split('%')[0] < 0 ? `url(${require('@/assets/img/downArrow.svg')})` : `url(${require('@/assets/img/rightArrow.svg')})`),
                            'background-size': '100% 100%'
                        }"></span>
                    </template>
                </Table>
            </box-border>
            <box-border
                title="采办进度"
                :boxStyle="{
                    'grid-row': '3 / span 2'
                }"
            >
                <span class="PAVstyle">
                    P: {{ procurementProgress.otherObj.P }} A: {{ procurementProgress.otherObj.A }} V: {{ procurementProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="procurementProgress"
                    :option="procurementProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="施工进度"
                :boxStyle="{
                    'grid-row': '5 / span 2'
                }"
            >
                <span class="PAVstyle">
                    P: {{ constructionProgress.otherObj.P }} A: {{ constructionProgress.otherObj.A }} V: {{ constructionProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="constructionProgress"
                    :option="constructionProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
        </div>
    </div>
</template>
<script>
    export default{
        name: 'PlanOne',
        data(){
            const obj = {
                dataZoom: [
                    {
                        height: this.fontSizeFn(20),
                        moveHandleSize: 0,
                        bottom: 10,
                        textStyle: {
                            color: '#8392A5'
                        },
                        dataBackground: {
                        areaStyle: {
                            color: '#8392A5'
                        },
                        lineStyle: {
                            opacity: 0.8,
                            color: '#8392A5'
                        }
                        },
                        brushSelect: true
                    }, {
                        type: 'inside',
                        filterMode: 'filter'
                    }
                ]
            }
            return {
                //overallProgress
                overallProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [5, 1, 0, 0, 1, 0],
                    legend: {
                        top: '0%'
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index == 3){
                                    item.data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${item.data.s7}<br/>`)
                                }else if(index == 5){
                                    item.data.s8.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s8}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    ...obj
                },
                //engineeringProgress
                engineeringProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [5, 1, 0, 0, 1, 0],
                    legend: {
                        top: '0%'
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index == 3){
                                    item.data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${item.data.s7}<br/>`)
                                }else if(index == 5){
                                    item.data.s8.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s8}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    ...obj
                },
                //Progress Table
                tableObj: {

                },
                //Procurement Progress
                procurementProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [5, 1, 0, 0, 1, 0],
                    legend: {
                        top: '0%'
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index == 3){
                                    item.data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${item.data.s7}<br/>`)
                                }else if(index == 5){
                                    item.data.s8.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s8}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    ...obj
                },
                //constructionProgress
                constructionProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [5, 1, 0, 0, 1, 0],
                    legend: {
                        top: '0%'
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index == 3){
                                    item.data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${item.data.s7}<br/>`)
                                }else if(index == 5){
                                    item.data.s8.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s8}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    ...obj
                },
                topBarDatas: [],
                stype: 'Project',
            }
        },
        mounted() {
            this.topBarDatas = [
                {
                    name: 'Overall',
                    fn: () => {
                        this.stype = 'Project';
                        this.renderFn();
                    }
                },
                {
                    name: 'CPF & Wellpad & IFL & WIS',
                    fn: () => {
                        this.stype = 'CPF & Wellpad & IFL & WIS';
                        this.renderFn();
                    }
                },
                {
                    name: 'Temporary Camp',
                    fn: () => {
                        this.stype = 'TCP';
                        this.renderFn();
                    }
                },
                // {
                //     name: 'WIS',
                //     fn: () => {
                //         this.stype = 'WIS';
                //         this.renderFn();
                //     }
                // }
            ]
        },
        methods: {
            renderFn(){
                const getxhrArr = [
                    async () => {
                        this.getNewVTos({
                                id: '2c92808f824759e401825c3698c20054',
                                stype: this.stype
                            },
                            [
                                ['Baseline', '累计计划', '累计实际', '累计预测', '本周计划', '本周实际'],
                                ['line', 'line', 'line', 'line', 'bar', 'bar'],
                                [1, 1, 1, 1, 0, 0]
                            ],
                            this.$refs.overallProgress.myChart,
                            {
                                name: 'overallProgress',
                                hasMoreData: ['s7', 's8'],
                                yAxisLines: 4,
                                yMaxArr: [ null, 100 ],
                                moreSetting: [
                                    {},
                                    {},
                                    {},
                                    {
                                        lineStyle: {
                                        type: 'dashed'
                                        }
                                    },
                                ]
                            },
                            (res) => {
                                this.$nextTick(() => {
                                    this.$refs.overallProgress.myChart.dispatchAction({
                                        type: 'showTip',
                                        seriesIndex: 0,
                                        dataIndex: res.s3.findLastIndex(item => item !== ' ')
                                    });
                                    const dataIndex = res.s3.findLastIndex(item => item !== ' ');
                                    this.$set(this.overallProgress.otherObj, 'P', res.s2[dataIndex]);
                                    this.$set(this.overallProgress.otherObj, 'A', res.s3[dataIndex]);
                                    this.$set(this.overallProgress.otherObj, 'V', res.s7[dataIndex]);
                                })
                            }
                        )
                    },
                    async () => {
                        this.getNewVTos({
                                id: '2c92808f824759e401825c373c810055',
                                stype: this.stype
                            },
                            [
                                ['Baseline', '累计计划', '累计实际', '累计预测', '本周计划', '本周实际'],
                                ['line', 'line', 'line', 'line', 'bar', 'bar'],
                                [1, 1, 1, 1, 0, 0]
                            ],
                            this.$refs.engineeringProgress.myChart,
                            {
                                name: 'engineeringProgress',
                                hasMoreData: ['s7', 's8'],
                                yAxisLines: 4,
                                yMaxArr: [ null, 100 ],
                                moreSetting: [
                                    {},
                                    {},
                                    {},
                                    {
                                        lineStyle: {
                                        type: 'dashed'
                                        }
                                    },
                                ]
                            },
                            (res) => {
                                const dataIndex = res.s3.findLastIndex(item => item !== ' ');
                                this.$set(this.engineeringProgress.otherObj, 'P', res.s2[dataIndex]);
                                this.$set(this.engineeringProgress.otherObj, 'A', res.s3[dataIndex]);
                                this.$set(this.engineeringProgress.otherObj, 'V', res.s7[dataIndex]);
                            }
                        )
                    },
                    async () => {
                        const data = await this.getTableData('2c92808f828168cf01828b75949a0016', this.stype);
                        this.tableObj = data;
                    },
                    async () => {
                        this.getNewVTos({
                                id: '2c92808f824759e401825c37617b0056',
                                stype: this.stype
                            },
                            [
                                ['Baseline', '累计计划', '累计实际', '累计预测', '本周计划', '本周实际'],
                                ['line', 'line', 'line', 'line', 'bar', 'bar'],
                                [1, 1, 1, 1, 0, 0]
                            ],
                            this.$refs.procurementProgress.myChart,
                            {
                                name: 'procurementProgress',
                                hasMoreData: ['s7', 's8'],
                                yAxisLines: 4,
                                yMaxArr: [ null, 100 ],
                                moreSetting: [
                                    {},
                                    {},
                                    {},
                                    {
                                        lineStyle: {
                                        type: 'dashed'
                                        }
                                    },
                                ]
                            },
                            (res) => {
                                const dataIndex = res.s3.findLastIndex(item => item !== ' ');
                                this.$set(this.procurementProgress.otherObj, 'P', res.s2[dataIndex]);
                                this.$set(this.procurementProgress.otherObj, 'A', res.s3[dataIndex]);
                                this.$set(this.procurementProgress.otherObj, 'V', res.s7[dataIndex]);
                            }
                        )
                    },
                    async () => {
                        this.getNewVTos({
                                id: '2c92808f824759e401825c378cd00057',
                                stype: this.stype
                            },
                            [
                                ['Baseline', '累计计划', '累计实际', '累计预测', '本周计划', '本周实际'],
                                ['line', 'line', 'line', 'line', 'bar', 'bar'],
                                [1, 1, 1, 1, 0, 0]
                            ],
                            this.$refs.constructionProgress.myChart,
                            {
                                name: 'constructionProgress',
                                hasMoreData: ['s7', 's8'],
                                yAxisLines: 4,
                                yMaxArr: [ null, 100 ],
                                moreSetting: [
                                    {},
                                    {},
                                    {},
                                    {
                                        lineStyle: {
                                        type: 'dashed'
                                        }
                                    },
                                ]
                            },
                            (res) => {
                                const dataIndex = res.s3.findLastIndex(item => item !== ' ');
                                this.$set(this.constructionProgress.otherObj, 'P', res.s2[dataIndex]);
                                this.$set(this.constructionProgress.otherObj, 'A', res.s3[dataIndex]);
                                this.$set(this.constructionProgress.otherObj, 'V', res.s7[dataIndex]);
                            }
                        )
                    }
                ];
                this.getAllPromise(getxhrArr);
            }
        },
    }
</script>
<style lang="less" scoped>
    .banner{
        padding-top: 0.12rem;
    }
    .contentBox{
        height: 92%;
        width: 100%;
        .gridStyle(2, 6, 0.24rem, 0.1rem);
    }
</style>